import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { I2faResponse, I2faType, SessionService, User } from 'pod-ng-core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';

interface ISet2faSmsModel {
  password?: string;
  phoneNumber: string;
}

@Component({
  selector: 'app-set-2fa-sms',
  templateUrl: './set-2fa-sms.component.html',
})
export class Set2faSmsComponent implements OnInit {
  @Input() user?: User;
  @Input() token?: string;
  @Input() blockButtons = false;
  @Output() onSubmit = new EventEmitter<I2faResponse>();
  @Output() onUserUpdated = new EventEmitter<User>();
  @Output() onCancel = new EventEmitter<void>();

  @ViewChild('phoneInput', { static: true }) phoneInput: ElementRef;

  public model: ISet2faSmsModel;
  public submitting = false;

  public get askCurrentPassword() {
    return this.user && this.user.getId() === this.session.user.getId();
  }

  constructor(
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private session: SessionService
  ) {}

  ngOnInit() {
    this.model = {
      password: null,
      phoneNumber: null,
    };
  }

  public submit(form: NgForm) {
    if (form.valid) {
      this.submitting = true;

      if (this.user) {
        this.session
          .set2faValueByUser(
            I2faType.SMS,
            this.model.phoneNumber,
            this.user.getId(),
            this.askCurrentPassword ? this.model.password : undefined
          )
          .pipe(finalize(() => (this.submitting = false)))
          .subscribe(user => {
            this.toastrService.success(
              this.translateService.instant(
                'message.phoneNumberSetSuccessfully'
              )
            );
            this.onUserUpdated.emit(user);
          });
      } else {
        this.session
          .set2faValueByToken(I2faType.SMS, this.token, this.model.phoneNumber)
          .pipe(finalize(() => (this.submitting = false)))
          .subscribe(user => {
            this.toastrService.success(
              this.translateService.instant(
                'message.phoneNumberSetSuccessfully'
              )
            );
            this.onSubmit.emit(user);
          });
      }
    }
  }
}
